import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './styles/globals.css'
import App from './app.tsx'
import { initSentry } from './sentry'

// Initialize Sentry for error tracking
initSentry();

// Initialize react-grab dev tool in development mode
if (import.meta.env.DEV) {
  import('react-grab').catch((error) => {
    console.warn('Failed to load react-grab dev tool:', error);
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
